import React from 'react';
import {inject, observer} from 'mobx-react';

@inject('sessionStore')
@observer
class Logo extends React.Component {
  render() {
    const ouInfo = this.props.sessionStore.workingOrganization;
    const logo = ouInfo && ouInfo.logo;
    const ouName = ouInfo && ouInfo.name;

    return (
      <div className='logo'>
        <a
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = '/';
          }}
        >
          <div className='sub'>{logo ? <img className='portal-logo' src={logo} alt='logo' /> : ''}</div>
        </a>
        {this.props.fromAdminConsole && (
          <div className='ou-name' title={ouName}>
            {ouName}
          </div>
        )}
      </div>
    );
  }
}

export default Logo;
